/* eslint-disable max-classes-per-file */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { AmplifyAuthenticatorModule } from "@aws-amplify/ui-angular";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";
import { MuseumAuthComponent } from "./museum-auth/museum-auth.component";
import { MuseumAuthPseudoComponent } from "./museum-auth-pseudo/museum-auth-pseudo.component";
import { MuseumAuthWaitingComponent } from "./museum-auth-waiting/museum-auth-waiting.component";
import { FastConnectComponent } from "./fast-connect/fast-connect.component";

const routes: Routes = [
    {
        path: "connect",
        component: MuseumAuthComponent,
    },
    {
        path: "redirect",
        component: FastConnectComponent,
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
class MuseumAuthRoutingModule {}

@NgModule({
    declarations: [
        MuseumAuthComponent,
        MuseumAuthPseudoComponent,
        MuseumAuthWaitingComponent,
        FastConnectComponent,
    ],
    imports: [
        FormsModule,
        CommonModule,
        MuseumAuthRoutingModule,
        TranslateModule,
        AmplifyAuthenticatorModule,
        SharedModule,
    ],
})
export class MuseumAuthModule {}
